module.exports = __webpack_public_path__ + "KMProna-StLipa.jpg?22517a11e1b14171670f2be7581487c9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/KMProna-StLipa.jpg
// module id = 242
// module chunks = 0